import { render, staticRenderFns } from "./rankDialog.vue?vue&type=template&id=f801385a&scoped=true"
import script from "./rankDialog.vue?vue&type=script&lang=js"
export * from "./rankDialog.vue?vue&type=script&lang=js"
import style0 from "./rankDialog.vue?vue&type=style&index=0&id=f801385a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f801385a",
  null
  
)

export default component.exports